import _Promise from "babel-runtime/core-js/promise";

export default {
  loadBusiData: function loadBusiData(newData, busiData) {
    var bizData = busiData.BIZ_DATA;
    return new _Promise(function (resolve) {
      var surveyInfo = _.cloneDeep(_.get(bizData, "SURVEY_RESULT_LIST[0]")) || {};
      if (surveyInfo) {
        var surveyColArr = surveyInfo.SURVEY_COL_ARR || [];
        var surveyResult = surveyInfo.SURVEY_RESULT || [];
        if (surveyColArr.length && surveyResult.length) {
          var map = {
            "1": "A",
            "2": "B",
            "3": "C",
            "4": "D",
            "5": "E",
            "6": "F",
            "7": "G"
          };

          var _loop = function _loop(i) {
            var colArrJSONObject = surveyColArr[i];
            var resultJSONObject = _.find(surveyResult, function (v) {
              return v.SURVEY_COL == colArrJSONObject.SURVEY_COL;
            });
            if (resultJSONObject) {
              var arr = resultJSONObject.SURVEY_CELLS.split(",");
              var str = "";
              for (var k = 0; k < arr.length; k++) {
                str += map[arr[k]] + "、";
              }
              colArrJSONObject.SURVEY_ANS_CELL = str.substring(0, str.length - 1);
            }
          };

          for (var i = 0; i < surveyColArr.length; i++) {
            _loop(i);
          }
        }
      }
      newData.surveyResults = surveyInfo;
      resolve(newData);
      return;
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/busi-paper/prints/GUOTOU/Xb6.js
// module id = 1133
// module chunks = 2